<template>
  <v-text-field
    :prepend-icon="schema.icon"
    :name="name"
    :label="schema.label"
    :value="value"
    :type="schema.type"
    :required="!schema.optional"
    :rules="numberFieldRules"
    :error-messages="errorMessages"
    @input="handleInput"
    :solo="schema.solo"
  />
</template>
<script>
import numeral from '@/plugins/numeral'
export default {
  props: {
    /** Current Value */
    value: { type: Number },
    /** Validation Errors */
    errorMessages: { type: String },
    /** Field Name */
    name: { type: String, required: true },
    /** Field Schema */
    schema: { type: Object, default: () => ({}) },
    /** Disabled state */
    disabled: { type: Boolean, default: false }
  },
  components: {
  },
  data () {
    return {
      numberFieldRules: [
        v => !!v || 'El campo es obligatorio'
      ]
    }
  },
  methods: {
    displayValue () {
      if (this.value == null) return
      return numeral(this.value).format('0,0.[00]')
    },
    /** Validation Rules */
    validationRules () {
      const rules = []
      // Number validation
      rules.push((v) => !v || !isNaN(numeral(v).value()) || 'Valor debe ser numérico')
      // Required validation
      if (!this.schema.optional) {
        rules.push((v) => v != null || 'Campo Requerido.')
      }
      // Integer validation
      if (this.fieldOptions.integer) {
        rules.push((v) => numeral(v).value() % 1 === 0 || 'Valor debe ser entero.')
      }
      return rules
    },
    /** Input event handler */
    handleInput (value) {
      this.$emit('input', value !== '' ? numeral(value).value() : undefined)
    }

  }
}
</script>
